var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaAndererOnlineAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:none;}.cls-2{mix-blend-mode:lighten;opacity:0.5;}.cls-4{fill:#e6af78;}.cls-5{fill:#59667c;}.cls-6{fill:#d29b6e;}.cls-7{fill:#f0c087;}.cls-8{fill:#3b485e;}.cls-9{fill:#785550;}.cls-10{fill:#694b4b;}.cls-11{fill:#5a4146;}.cls-12{fill:#e3e3e3;stroke:#59667c;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98 90.02 98 76.02 62 76.02 62 90.02 80 106.02 98 90.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.84,96.57l-24.75-5.83a3.39,3.39,0,0,1-1-.42L80,102,60.73,89.76a3.89,3.89,0,0,1-1.82,1L34.16,96.57A8,8,0,0,0,28,104.36V120a4,4,0,0,0,4,4h96a4,4,0,0,0,4-4V104.36A8,8,0,0,0,125.84,96.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62,76V90.79C84.68,99,98,78.51,98,78.51V76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M54,30l1.74,38.35a12,12,0,0,0,4.79,9l8.27,6.21A12.05,12.05,0,0,0,76,86h8a12.05,12.05,0,0,0,7.2-2.4l8.27-6.21a12,12,0,0,0,4.79-9L106,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74,38c8,0,20-2,22.85-8H54l1.74,38.35a12,12,0,0,0,4.79,9l8.27,6.21A12.05,12.05,0,0,0,76,86h4c-4,0-12-8-12-18V44C68,42,70,38,74,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.32,111l13-11.64a8,8,0,0,1,1.73,5V120a4,4,0,0,1-4,4H114v-5.54A10,10,0,0,1,117.32,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.68,111l-13-11.64a8,8,0,0,0-1.73,5V120a4,4,0,0,0,4,4H46v-5.54A10,10,0,0,0,42.68,111Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "85 124.02 75 124.02 76.25 106.02 83.75 106.02 85 124.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85,102H75v1.15A4.85,4.85,0,0,0,79.84,108h.32A4.85,4.85,0,0,0,85,103.17V102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.72,85.56,80,102a68.78,68.78,0,0,0-11.44,7.79,2.56,2.56,0,0,1-4-.9L56,90l2.71-4.08A2,2,0,0,1,61.72,85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.28,85.56,80,102a68.78,68.78,0,0,1,11.44,7.79,2.56,2.56,0,0,0,4-.9L104,90l-2.71-4.08A2,2,0,0,0,98.28,85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.13,16.76,94,30c8.56,1.71,9.8,15.14,10,19a4,4,0,0,0,.64,2L107.87,56s-1.12-8.37,4-14C111.87,42,113.63,8.76,92.13,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M109.88,55.16l-2.26,9A2.41,2.41,0,0,1,105.29,66h0a2.4,2.4,0,0,1-2.39-2.1l-1.15-9.24a4.13,4.13,0,0,1,4.1-4.66h0A4.14,4.14,0,0,1,109.88,55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M55.91,13.17l3,2C45.5,25.07,48,42,48,42c4,4,4,14,4,14l4-4s-1.55-11.55,6-16c7-4.13,13.13-2,19.38-2C98.13,34,102.82,27.7,102,20c-.42-4-6.5-12.27-22-12C73.74,8.11,62,10,55.91,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M54.75,32.26s-2.13-8.38,4.12-17.07C45.5,25.07,48,42,48,42c4,4,4,14,4,14l4-4s-1.55-11.55,6-16c7-4.13,13.13-2,19.38-2a48.16,48.16,0,0,0,7.21-.5C75.69,34,68.08,24.17,54.75,32.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.12,55.16l2.26,9A2.41,2.41,0,0,0,54.71,66h0a2.4,2.4,0,0,0,2.39-2.1l1.16-9.24A4.15,4.15,0,0,0,54.15,50h0A4.15,4.15,0,0,0,50.12,55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104,120H94a4,4,0,0,0-4,4h18A4,4,0,0,0,104,120Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.75,
    y: 133.52,
    width: 104.5,
    height: 18.48,
    rx: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "127.74 142.76 120.61 137.69 120.61 147.83 127.74 142.76"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaAndererOnlineAccount);
export default __webpack_public_path__ + "static/media/ka_anderer_online_account.72fe68271181530ddd7b8dd93af6c727.svg";
export { ForwardRef as ReactComponent };